import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import * as paymentService from "data/server_apis/paymentService";
const initialState = {
  createPaymentTypeLoading: false,
  createPaymentTypeError: false,
  createPaymentTypeErrorMessage: null,
  createPaymentTypeSuccess: false,

  createPaymentAssignmentLoading: false,
  createPaymentAssignmentError: false,
  createPaymentAssignmentErrorMessage: null,
  createPaymentAssignmentSuccess: false,


  updatePaymentAssignmentLoading: false,
  updatePaymentAssignmentError: false,
  updatePaymentAssignmentErrorMessage: null,
  updatePaymentAssignmentSuccess: false,

  getPaymentsForMachineLoading: false,
  getPaymentsForMachineError: false,
  getPaymentsForMachineErrorMessage: null,
  getPaymentsForMachineSuccess: false,

  deletePaymentsForMachineLoading: false,
  deletePaymentsForMachineError: false,
  deletePaymentsForMachineErrorMessage: null,
  deletePaymentsForMachineSuccess: false,

  paymentTypes: [],
  paymentAssignMent: [],
  paymentsForMachine: {},
  paymentAssignmentInMachine: {},
};

// Payment types

export const getPaymentTypesThunk = createAsyncThunk(
  "vending/getPaymentTypes",
  async (_, { rejectWithValue }) => {
    try {
      return (await paymentService.getPaymentTypes()).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

// Payments for machine

export const getPaymentsForMachineThunk = createAsyncThunk(
  "vending/getPaymentsForMachine",
  async (id, { rejectWithValue }) => {
    try {
      return (await paymentService.getPaymentsForMachine(id)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

// Payment assignment
export const createPaymentAssignmentThunk = createAsyncThunk(
  "vending/createPayment",
  async (data, { rejectWithValue }) => {
    // console.log("Payment assignment", data);
    try {
      return (await paymentService.createPaymentAssignment(data)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);

      return rejectWithValue(customError);
    }
  }
);

export const updatePaymentAssignmentThunk = createAsyncThunk(
  "vending/updatePaymentAssignment",
  async ({id,data}, { rejectWithValue }) => {
    // console.log("Payment assignment", data);
    try {
      return (await paymentService.updatePaymentAssignment(id,data)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);

      return rejectWithValue(customError);
    }
  }
);

export const deletePaymentAssignmentThunk = createAsyncThunk(
  "vending/getPaymentsForMachine",
  async (id, { rejectWithValue }) => {
    try {
      return (await paymentService.deletePaymentAssignment(id)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const getPaymentAssignmentForMachineThunk = createAsyncThunk(
  "vending/getPaymentAssignmentForMachine",
  async ({ payment, machine }, { rejectWithValue }) => {
    try {
      
      return (
        await paymentService.getPaymentAssignmentForMachineWithPaymentId(
          payment,
          machine
        )
      ).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

// Delete payment for machine

export const deletePaymentsForMachineThunk = createAsyncThunk(
  "vending/deletePaymentsForMachine",
  async (data, { rejectWithValue }) => {
    try {
      return (await paymentService.deletePaymentsForMachine(data)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

const payments = createSlice({
  name: "payment",
  initialState,
  reducers: {
    clearPayments(state, action) {
      state.createPaymentTypeLoading = false;
      state.createPaymentTypeError = false;
      state.createPaymentTypeErrorMessage = null;
      state.createPaymentTypeSuccess = false;

      state.createPaymentAssignmentLoading = false;
      state.createPaymentAssignmentError = false;
      state.createPaymentAssignmentErrorMessage = null;
      state.createPaymentAssignmentSuccess = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPaymentTypesThunk.pending, (state, action) => {
        state.createPaymentTypeLoading = true;
        state.createPaymentTypeError = false;
        state.createPaymentTypeErrorMessage = null;
        state.createPaymentTypeSuccess = false;
      })
      .addCase(getPaymentTypesThunk.rejected, (state, action) => {
        state.createPaymentTypeLoading = false;
        state.createPaymentTypeError = true;
        state.createPaymentTypeErrorMessage = action.payload?.message;
        state.createPaymentTypeSuccess = false;
      })
      .addCase(getPaymentTypesThunk.fulfilled, (state, action) => {
        state.createPaymentTypeLoading = false;
        state.createPaymentTypeError = false;
        state.createPaymentTypeErrorMessage = null;
        state.createPaymentTypeSuccess = true;
        state.paymentTypes = action.payload;
      });
    builder
      .addCase(getPaymentsForMachineThunk.pending, (state, action) => {
        state.getPaymentsForMachineLoading = true;
        state.getPaymentsForMachineError = false;
        state.getPaymentsForMachineErrorMessage = null;
        state.getPaymentsForMachineSuccess = false;
      })
      .addCase(getPaymentsForMachineThunk.rejected, (state, action) => {
        state.getPaymentsForMachineLoading = false;
        state.getPaymentsForMachineError = true;
        state.getPaymentsForMachineErrorMessage = action.payload?.message;
        state.getPaymentsForMachineSuccess = false;
      })
      .addCase(getPaymentsForMachineThunk.fulfilled, (state, action) => {
        state.getPaymentsForMachineLoading = false;
        state.getPaymentsForMachineError = false;
        state.getPaymentsForMachineErrorMessage = null;
        state.getPaymentsForMachineSuccess = true;
        state.paymentsForMachine[action.meta.arg] = action.payload;
      });
    builder
      .addCase(deletePaymentsForMachineThunk.pending, (state, action) => {
        state.deletePaymentsForMachineLoading = true;
        state.deletePaymentsForMachineError = false;
        state.deletePaymentsForMachineErrorMessage = null;
        state.deletePaymentsForMachineSuccess = false;
      })
      .addCase(deletePaymentsForMachineThunk.rejected, (state, action) => {
        state.deletePaymentsForMachineLoading = false;
        state.deletePaymentsForMachineError = true;
        state.deletePaymentsForMachineErrorMessage = action.payload?.message;
        state.deletePaymentsForMachineSuccess = false;
      })
      .addCase(deletePaymentsForMachineThunk.fulfilled, (state, action) => {
        state.deletePaymentsForMachineLoading = false;
        state.deletePaymentsForMachineError = false;
        state.deletePaymentsForMachineErrorMessage = null;
        state.deletePaymentsForMachineSuccess = true;
        console.log(action.meta.arg);
        state.paymentsForMachine[action.meta.arg.machine] =
          state.paymentsForMachine[action.meta.arg.machine]?.filter(
            (item) => item.id !== action.meta.arg.payment
          );
      });

    // Assign payments
    builder
      .addCase(createPaymentAssignmentThunk.pending, (state, action) => {
        state.createPaymentAssignmentLoading = true;
        state.createPaymentAssignmentError = false;
        state.createPaymentAssignmentErrorMessage = null;
        state.createPaymentAssignmentSuccess = false;
      })
      .addCase(createPaymentAssignmentThunk.rejected, (state, action) => {
        state.createPaymentAssignmentLoading = false;
        state.createPaymentAssignmentError = true;
        state.createPaymentAssignmentErrorMessage = action.payload?.message;
        state.createPaymentAssignmentSuccess = false;
      })
      .addCase(createPaymentAssignmentThunk.fulfilled, (state, action) => {
        state.createPaymentAssignmentLoading = false;
        state.createPaymentAssignmentError = false;
        state.createPaymentAssignmentErrorMessage = null;
        state.createPaymentAssignmentSuccess = true;
      });

    builder
      .addCase(getPaymentAssignmentForMachineThunk.pending, (state, action) => {
        const { payment, machine } = action.meta.arg;
        state.updatePaymentAssignmentSuccess = false;
        if (!state.paymentAssignmentInMachine[payment]) {
          state.paymentAssignmentInMachine[payment] = {};
        }
      
        if (!state.paymentAssignmentInMachine[payment][machine]) {
          state.paymentAssignmentInMachine[payment][machine] = {};
        }
      
        state.paymentAssignmentInMachine[payment][machine].status = "loading";
      })
      .addCase(getPaymentAssignmentForMachineThunk.rejected, (state, action) => {
        const { payment, machine } = action.meta.arg;
      
        if (!state.paymentAssignmentInMachine[payment]) {
          state.paymentAssignmentInMachine[payment] = {};
        }
      
        if (!state.paymentAssignmentInMachine[payment][machine]) {
          state.paymentAssignmentInMachine[payment][machine] = {};
        }
      
        state.paymentAssignmentInMachine[payment][machine].status = "error";
      })
      .addCase(getPaymentAssignmentForMachineThunk.fulfilled, (state, action) => {
        const { payment, machine } = action.meta.arg;
      
        if (!state.paymentAssignmentInMachine[payment]) {
          state.paymentAssignmentInMachine[payment] = {};
        }
      
        if (!state.paymentAssignmentInMachine[payment][machine]) {
          state.paymentAssignmentInMachine[payment][machine] = {};
        }
      
        state.paymentAssignmentInMachine[payment][machine].status = "success";
        state.paymentAssignmentInMachine[payment][machine].data = action.payload;
      });
      

    builder
      .addCase(updatePaymentAssignmentThunk.pending, (state, action) => {
      state.updatePaymentAssignmentLoading = true;
      state.updatePaymentAssignmentError = false;
      state.updatePaymentAssignmentErrorMessage = null;
      state.updatePaymentAssignmentSuccess = false;
      })
      .addCase(updatePaymentAssignmentThunk.rejected, (state, action) => {
      state.updatePaymentAssignmentLoading = false;
      state.updatePaymentAssignmentError = true;
      state.updatePaymentAssignmentErrorMessage = action.payload?.message;
      state.updatePaymentAssignmentSuccess = false;
      })
      .addCase(updatePaymentAssignmentThunk.fulfilled, (state, action) => {
      state.updatePaymentAssignmentLoading = false;
      state.updatePaymentAssignmentError = false;
      state.updatePaymentAssignmentErrorMessage = null;
      state.updatePaymentAssignmentSuccess = true;
      });
  },
});

export const { clearPayments } = payments.actions;

export default payments.reducer;
